import { Link } from "react-router-dom";
import { SealCheck } from "@phosphor-icons/react";
import { trendingTags, suggestedArtists, disciplines } from "@/data/mockData";

export default function RightRail() {
  return (
    <div className="space-y-6">
      {/* Trending */}
      <section className="border border-[#27272A]">
        <header className="px-4 py-3 border-b border-[#27272A] flex items-center justify-between">
          <h3 className="font-display font-bold uppercase tracking-tight text-sm">
            Tendencias
          </h3>
          <span className="font-mono text-[10px] text-[#FF3E00] tracking-[0.2em]">
            LIVE
          </span>
        </header>
        <ul>
          {trendingTags.map((t, i) => (
            <li
              key={t.tag}
              className="flex items-center justify-between px-4 py-3 border-b border-[#27272A] last:border-b-0 hover:bg-[#121212] cursor-pointer transition-colors"
            >
              <div className="flex items-center gap-3">
                <span className="font-mono text-[10px] text-[#A1A1AA]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="font-display font-semibold text-[15px] text-[#FF3E00]">
                  {t.tag}
                </span>
              </div>
              <span className="font-mono text-[10px] text-[#A1A1AA] tracking-wider">
                {t.posts}
              </span>
            </li>
          ))}
        </ul>
      </section>

      {/* Suggested Artists */}
      <section className="border border-[#27272A]">
        <header className="px-4 py-3 border-b border-[#27272A]">
          <h3 className="font-display font-bold uppercase tracking-tight text-sm">
            Descubre
          </h3>
          <p className="font-mono text-[10px] text-[#A1A1AA] mt-1 tracking-wider">
            ARTISTAS SUGERIDOS
          </p>
        </header>
        <ul>
          {suggestedArtists.filter(Boolean).map((a) => (
            <li
              key={a.slug}
              className="flex items-center gap-3 px-4 py-3 border-b border-[#27272A] last:border-b-0"
            >
              <Link to={`/artista/${a.slug}`} className="shrink-0">
                <img
                  src={a.avatar}
                  alt={a.name}
                  className="h-11 w-11 object-cover border border-[#27272A]"
                />
              </Link>
              <div className="flex-1 min-w-0">
                <Link
                  to={`/artista/${a.slug}`}
                  className="flex items-center gap-1 font-display font-semibold text-sm hover:text-[#FF3E00]"
                >
                  <span className="truncate">{a.name}</span>
                  {a.verified ? (
                    <SealCheck
                      size={14}
                      weight="fill"
                      className="text-[#FF3E00] shrink-0"
                    />
                  ) : null}
                </Link>
                <div className="font-mono text-[10px] text-[#A1A1AA] truncate">
                  {a.role}
                </div>
              </div>
              <button
                data-testid={`follow-${a.slug}`}
                className="btn-brutal font-mono uppercase text-[10px] tracking-[0.2em] px-3 py-1.5 border border-[#F4F4F5] hover:bg-[#FF3E00] hover:border-[#FF3E00] hover:text-white"
              >
                Seguir
              </button>
            </li>
          ))}
        </ul>
      </section>

      {/* Disciplines */}
      <section className="border border-[#27272A]">
        <header className="px-4 py-3 border-b border-[#27272A]">
          <h3 className="font-display font-bold uppercase tracking-tight text-sm">
            Disciplinas
          </h3>
        </header>
        <div className="p-3 flex flex-wrap gap-2">
          {disciplines.map((d) => (
            <Link
              key={d.slug}
              to={`/explorar?discipline=${d.slug}`}
              className="font-mono text-[10px] uppercase tracking-[0.18em] border border-[#27272A] text-[#A1A1AA] hover:text-black hover:bg-[#F4F4F5] hover:border-[#F4F4F5] px-2 py-1.5 transition-colors"
            >
              {d.name}
            </Link>
          ))}
        </div>
      </section>

      <footer className="font-mono text-[10px] text-[#A1A1AA] tracking-wider px-1 leading-relaxed">
        © 2026 · ELARTE/NET · MOCKUP VISUAL ·<br />
        MADE BY THE COMMUNITY FOR THE COMMUNITY.
      </footer>
    </div>
  );
}
